import styled from 'styled-components';
import WithDirection from '../../../config/withDirection';

export default WithDirection(styled.div`
    .sign-in {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #fff;
        height: 40px;
        padding: 0 28px;
        background-color: transparent;
        color: #fff;
        border-radius: 100px;
    }
    .sign-in:hover { background-color: #fff; color: rgba(35, 31, 32, 1); opacity: 1; }

    @media screen and (max-width: 767px) {
        .sign-in { padding: 4px; height: auto; border-radius: 3px; }
    }
`);


// WEBPACK FOOTER //
// ./src/components/Headers/LoginButton/Wrapper.js